import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import colors from '@app/constants/colors';
import RouterConstants from '@app/constants/router';
import { Loader, Button, PackageInformation } from '@app/components';
import { getAvailableOptions, checkSubscriptionValidity } from '@app/actions/subscribeActions';

class CurrentSubscriptions extends React.Component {
  componentDidMount() {
    const { getAvailableOptions, checkSubscriptionValidity } = this.props;
    checkSubscriptionValidity();
    getAvailableOptions();
  }

  renderSubscriptions = () => {
    const { userOptions } = this.props;

    return userOptions.length
      ? userOptions.map(option => (
        <PackageInformation
          key={option.optionId}
          option={option}
          disabled={!!option}
          onOptionSelect={() => {}}
        />
      ))
      : (
        <React.Fragment>
          <Message>
            <FormattedMessage id="subscription.noPackages" />
          </Message>
          <Button
            wide
            bordered
            labelId="package.select"
            textColor={colors.ALIZARIN_CRIMSON}
            backgroundColor={colors.SUPERNOVA}
            path={RouterConstants.SUBSCRIBE}
          />
        </React.Fragment>
      );
  };

  render() {
    const { isLoadingOptions } = this.props;

    return (
      <PageContainer>
        <Title>
          <FormattedMessage id="subscription.current" />
        </Title>
        <Subscriptions>
          { isLoadingOptions ? <Loader /> : this.renderSubscriptions() }
        </Subscriptions>
      </PageContainer>
    );
  }
}

CurrentSubscriptions.propTypes = {
  checkSubscriptionValidity: PropTypes.func.isRequired,
  getAvailableOptions: PropTypes.func.isRequired,
  isLoadingOptions: PropTypes.bool.isRequired,
  userOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const mapStateToProps = ({
  subscribe: { isLoadingOptions, userOptions },
}) => ({
  isLoadingOptions, userOptions,
});

const mapDispatchToProps = {
  checkSubscriptionValidity,
  getAvailableOptions,
};


export default connect(mapStateToProps, mapDispatchToProps)(CurrentSubscriptions);

const PageContainer = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;  
  max-width: 820px;
  border-bottom: 1px solid ${colors.HAWKES_BLUE};
`;

const Subscriptions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  min-height: 300px;
  padding: 0 0 20px;
  
  @media (max-width: 728px) {
    flex-direction: column;
  }  
`;

const Title = styled.h2`
  width: 100%;
  text-align: left;
  text-transform: uppercase;
`;

const Message = styled.span`
  padding-bottom: 30px;
`;
